import { render, staticRenderFns } from "./OrganizationEditForm.vue?vue&type=template&id=b2cddecc&"
import script from "./OrganizationEditForm.vue?vue&type=script&lang=js&"
export * from "./OrganizationEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports